export var throwError = function throwError(err) {
  throw err;
};